import axios from "axios";
import { config } from "../config";

const getChatHistoryApi = async (
  userId: string,
  accessToken: string
): Promise<any> => {
  try {
    const apiUrl = `${config.baseUrl}/api/chatbot/history/${userId}`;
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response || !response.data) {
      throw new Error("Empty response from chatbot");
    }

    return response.data;
  } catch (error) {
    return {
      data: {
        bot_response: {
          sources: [],
          response: config.errorResponseMessage,
        },
      },
    };
  }
};
const getUserGroupApi = async (
  userId: string,
  accessToken: string
): Promise<any> => {
  try {
    const apiUrl = `${config.baseUrl}/api/chatbot/groups/${userId}`;
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response || !response.data) {
      throw new Error("Empty response from chatbot");
    }

    return response.data;
  } catch (error) {
    return {
      data: {
        bot_response: {
          sources: [],
          response: config.errorResponseMessage,
        },
      },
    };
  }
};

export { getChatHistoryApi, getUserGroupApi };
